export const paramTextYPosition = 300;
